<template>
  <section>
    <div class="mt-5 mb-3 ml-0 mr-0 text-left">
      <b-card>
        <b-card-text>
          <h3>
            <font-awesome-icon icon="book-reader"/>
            {{ showTitle }}
            <span class="float-right" v-if="showCreateBtn">
              <router-link class="btn btn-md bg-orange" :to="{name: 'recipeAdd'}">Create a new recipe</router-link>
            </span>
          </h3>
        </b-card-text>
        <hr>
        <b-card-text>
          <div class="mb-3">
            <RecipesList v-bind:recipes="recipes"></RecipesList>
          </div>
          <div class="overflow-auto" v-if="showPagination">
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.totalCount"
              :per-page="pagination.pageSize"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              align="center"
              @input="getRecipes">
            </b-pagination>
          </div>
        </b-card-text>
      </b-card>
    </div>
  </section>
</template>

<script>
import RecipesList from './RecipesList'

export default {
  name: 'RecipesSection',
  data () {
    return {
      recipes: [],
      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 8
      }
    }
  },
  props: {
    'type': String
  },
  components: {
    RecipesList
  },
  created () {
    this.getRecipes()
  },
  computed: {
    showPagination: function () {
      // display or not the pagination bar
      return this.pagination.totalCount > this.pagination.pageSize
    },
    showCreateBtn: function () {
      // display or not the creation btn
      return this.type === 'OWN'
    },
    showTitle: function () {
      // get the type of displayed recipes
      if (this.type === 'OWN') {
        return 'My Recipes'
      } else if (this.type === 'SHARE') {
        return 'Shared Recipes'
      } else if (this.type === 'BOOKMARKED') {
        return 'Bookmarked Recipes'
      }
    }
  },
  methods: {
    initRecipes: function () {
      this.recipes = []
    },
    getRecipes: function () {
      // Fetch a list of recipes
      let params = {
        status: this.type,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize
      }
      // get data
      this.$store.dispatch('getRecipesList', params).then(
        data => {
          this.pagination.totalCount = data.totalCount
          this.initRecipes()
          this.recipes = data.results
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipesSection.vue